import { render, staticRenderFns } from "./ProjectLiveTalk.vue?vue&type=template&id=58d1d55d&scoped=true&"
import script from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"
export * from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLiveTalk.vue?vue&type=style&index=0&id=58d1d55d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1d55d",
  null
  
)

export default component.exports